<mat-card class="dataToBeUpdated-block">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.dataToBeUpdated.title.fullLabel"
                        | translate
                }}
                <app-tooltip
                    text="{{
                        'dashboardBizzDev.dataToBeUpdated.title.summary'
                            | translate
                    }}"
                ></app-tooltip>
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-height">
        <mat-tab-group color="accent" animationDuration="0ms">
            <mat-tab
                label="{{
                    'dashboardBizzDev.dataToBeUpdated.dataListsNames.city.bbc2020.shortLabel'
                        | translate
                }}"
            >
                <app-flanders-cities></app-flanders-cities>
            </mat-tab>
            <mat-tab
                label="{{
                    'dashboardBizzDev.dataToBeUpdated.dataListsNames.city.wallonia.shortLabel'
                        | translate
                }}"
            >
                <app-wallonia-cities></app-wallonia-cities>
            </mat-tab>
            <mat-tab
                label="{{
                    'dashboardBizzDev.dataToBeUpdated.dataListsNames.city.bruxelles.shortLabel'
                        | translate
                }}"
            >
                <app-bxl-cities></app-bxl-cities>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>
